export const validateLettersNumbersAndSpacialChars = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(
    /[^a-zA-Z0-9\u05D0-\u05EA\- ().,?!:'"\n]/g,
    ''
  );
};
